import { render } from "./classifyView.vue?vue&type=template&id=a5fc8218&scoped=true"
import script from "./classifyView.vue?vue&type=script&lang=js"
export * from "./classifyView.vue?vue&type=script&lang=js"

import "./classifyView.vue?vue&type=style&index=0&id=a5fc8218&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5fc8218"]])

export default __exports__